export const pricingPlans = [
  {
    id: 1,
    name: "Essential",
    price: "$49",
    federal: "+ USPTO Filing Fee",
    recommended: false,
    features: [
      "Case review & evaluation",
      "USPTO trademark application",
      "Basic trademark search",
      "State e-filing included",
      "Email status updates"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Get Started"
  },
  {
    id: 2,
    name: "Professional",
    price: "$199",
    federal: "+ USPTO Filing Fee",
    recommended: true,
    features: [
      "Everything in Essential",
      "Comprehensive conflict search",
      "Trademark monitoring alerts",
      "Refusal risk assessment",
      "Priority support",
      "Status dashboard access"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Professional"
  },
  {
    id: 3,
    name: "Enterprise",
    price: "$399",
    federal: "+ USPTO Filing Fee",
    recommended: false,
    features: [
      "Everything in Professional",
      "Full clearance search report",
      "Dedicated case manager",
      "Office action response",
      "Cease & desist letter",
      "Multi-class filing support",
      "Dedicated attorney access"
    ],
    note: "USPTO govt. fee not included",
    buttonText: "Choose Enterprise"
  }
];

export const workProcess = [
  {
    id: 1,
    step: "01",
    title: "Comprehensive Search",
    description: "We analyze USPTO records, state databases, and common law sources to identify potential conflicts and assess your registration prospects before filing."
  },
  {
    id: 2,
    step: "02",
    title: "USPTO Filing",
    description: "Our trademark attorneys prepare your application with precise classification, proper specimens, and full documentation, then file directly with the USPTO."
  },
  {
    id: 3,
    step: "03",
    title: "Monitor & Protect",
    description: "We track your application through every USPTO stage, handle office actions, and keep you updated until your federal trademark certificate is issued."
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Licensed Trademark Attorneys",
    description: "Every trademark application is handled by experienced attorneys who understand USPTO requirements and federal IP law."
  },
  {
    id: 2,
    title: "Flat-Rate, Transparent Pricing",
    description: "No hidden fees. Our trademark registration services start at $49 and you know exactly what you pay before you begin."
  },
  {
    id: 3,
    title: "Fast Processing Times",
    description: "We prioritize efficiency. Trademark applications are prepared and filed within 48 hours of receiving your details."
  },
  {
    id: 4,
    title: "Dedicated Case Support",
    description: "A dedicated trademark specialist guides you through every step with real-time updates and direct communication."
  },
  {
    id: 5,
    title: "Office Action Handling",
    description: "If the USPTO issues a refusal or office action, our attorneys prepare professional legal responses to protect your application."
  },
  {
    id: 6,
    title: "Nationwide Federal Protection",
    description: "Federal trademark registration grants exclusive rights to your brand across all 50 states, enforceable in any US court."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "E-commerce Entrepreneur",
    content: "Brand Trademark Registration handled my entire USPTO filing flawlessly. My trademark was approved without a single issue, and the process was completely transparent from start to finish.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Startup Founder",
    content: "Their comprehensive trademark search uncovered conflicts I would have never found on my own. Saved my company from a costly rebranding and potential legal disputes down the line.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    role: "Online Retailer",
    content: "The Professional package was worth every dollar. From trademark search to final registration, the entire process was handled with precision and constant communication.",
    rating: 5
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Product Designer",
    content: "I needed trademark protection for my brand name and logo. The attorneys were knowledgeable, responsive, and made the entire USPTO application process stress-free.",
    rating: 5
  },
  {
    id: 5,
    name: "Amanda Stevens",
    role: "Small Business Owner",
    content: "Federal trademark registration gave my business the credibility and protection it needed. The flat-rate pricing and expert support made it an easy decision.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Wilson",
    role: "Brand Consultant",
    content: "I recommend Brand Trademark Registration to all my clients. Their Essential package at $49 is the most affordable way to get professional USPTO trademark filing.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is trademark registration and why does it matter?",
    answer: "Trademark registration is the legal process of securing exclusive rights to your brand name, logo, or slogan through the USPTO. It grants federal protection across all 50 states, prevents competitors from using similar marks, and enables use of the registered trademark symbol."
  },
  {
    id: 2,
    question: "How long does the trademark registration process take?",
    answer: "The complete process typically takes 8-12 months from filing to approval. USPTO examination begins within 3-4 months of submission. If approved, your mark enters a 30-day opposition period before final registration. Our team handles all office actions promptly to minimize delays."
  },
  {
    id: 3,
    question: "What does the $49 Essential package include?",
    answer: "The Essential package covers a thorough case review, complete USPTO trademark application filing, a basic trademark search, and state e-filing. It is ideal for straightforward applications with low conflict risk. Federal filing fees ($250-$350 per class) are paid separately to the USPTO."
  },
  {
    id: 4,
    question: "How do your trademark registration packages differ?",
    answer: "Essential ($49) covers basic filing and search. Professional ($199) adds comprehensive conflict search, monitoring alerts, risk assessment, and priority support. Enterprise ($399) includes a dedicated case manager, office action response, cease and desist letters, multi-class support, and dedicated attorney access."
  },
  {
    id: 5,
    question: "Is a trademark search necessary before filing?",
    answer: "A comprehensive trademark search is strongly recommended before filing. It examines USPTO databases, state registrations, and common law usage to identify potential conflicts. This step can save significant time and money by preventing rejections. Our Professional and Enterprise packages include thorough search services."
  },
  {
    id: 6,
    question: "What types of marks can be registered as trademarks?",
    answer: "You can register brand names, logos, slogans, product names, and other identifiers that distinguish your goods or services. The mark must be distinctive and not merely descriptive. Our attorneys assess the strength and registrability of your mark during consultation."
  },
  {
    id: 7,
    question: "What happens if my trademark application is refused?",
    answer: "If the USPTO issues an office action, our team prepares a professional legal response. We analyze the objection, develop strategic arguments, and submit a response within the required timeframe. Enterprise packages include office action response at no additional cost."
  },
  {
    id: 8,
    question: "What is the difference between state and federal trademark registration?",
    answer: "State registration protects your trademark only in that specific state, while federal USPTO registration provides protection across all 50 states. Federal registration also enables use of the registered symbol, listing in the USPTO database, and access to federal courts for enforcement."
  },
  {
    id: 9,
    question: "Can I register a trademark as an individual?",
    answer: "Yes, individuals can file trademark applications with the USPTO. You do not need a business entity. However, the trademark must be used in commerce or you must have a bona fide intent to use it. Our attorneys guide you on the correct filing basis during the consultation."
  },
  {
    id: 10,
    question: "What are the USPTO government filing fees?",
    answer: "USPTO filing fees range from $250-$350 per trademark class and are paid directly to the government, separate from our service fees. These are required for all trademark applications and are non-refundable. We identify appropriate classes during consultation and guide you through payment."
  }
];

export const countryCodes = [
  { code: '+1', country: 'US/Canada', flag: '\u{1f1fa}\u{1f1f8}' },
  { code: '+44', country: 'UK', flag: '\u{1f1ec}\u{1f1e7}' },
  { code: '+91', country: 'India', flag: '\u{1f1ee}\u{1f1f3}' },
  { code: '+86', country: 'China', flag: '\u{1f1e8}\u{1f1f3}' },
  { code: '+81', country: 'Japan', flag: '\u{1f1ef}\u{1f1f5}' },
  { code: '+49', country: 'Germany', flag: '\u{1f1e9}\u{1f1ea}' },
  { code: '+33', country: 'France', flag: '\u{1f1eb}\u{1f1f7}' },
  { code: '+39', country: 'Italy', flag: '\u{1f1ee}\u{1f1f9}' },
  { code: '+61', country: 'Australia', flag: '\u{1f1e6}\u{1f1fa}' },
  { code: '+55', country: 'Brazil', flag: '\u{1f1e7}\u{1f1f7}' },
  { code: '+52', country: 'Mexico', flag: '\u{1f1f2}\u{1f1fd}' },
  { code: '+7', country: 'Russia', flag: '\u{1f1f7}\u{1f1fa}' },
  { code: '+82', country: 'South Korea', flag: '\u{1f1f0}\u{1f1f7}' },
  { code: '+34', country: 'Spain', flag: '\u{1f1ea}\u{1f1f8}' },
  { code: '+31', country: 'Netherlands', flag: '\u{1f1f3}\u{1f1f1}' },
  { code: '+46', country: 'Sweden', flag: '\u{1f1f8}\u{1f1ea}' },
  { code: '+47', country: 'Norway', flag: '\u{1f1f3}\u{1f1f4}' },
  { code: '+41', country: 'Switzerland', flag: '\u{1f1e8}\u{1f1ed}' },
  { code: '+65', country: 'Singapore', flag: '\u{1f1f8}\u{1f1ec}' },
  { code: '+971', country: 'UAE', flag: '\u{1f1e6}\u{1f1ea}' },
  { code: '+966', country: 'Saudi Arabia', flag: '\u{1f1f8}\u{1f1e6}' },
  { code: '+27', country: 'South Africa', flag: '\u{1f1ff}\u{1f1e6}' },
  { code: '+64', country: 'New Zealand', flag: '\u{1f1f3}\u{1f1ff}' },
  { code: '+351', country: 'Portugal', flag: '\u{1f1f5}\u{1f1f9}' },
  { code: '+48', country: 'Poland', flag: '\u{1f1f5}\u{1f1f1}' },
  { code: '+20', country: 'Egypt', flag: '\u{1f1ea}\u{1f1ec}' },
  { code: '+90', country: 'Turkey', flag: '\u{1f1f9}\u{1f1f7}' },
  { code: '+62', country: 'Indonesia', flag: '\u{1f1ee}\u{1f1e9}' },
  { code: '+63', country: 'Philippines', flag: '\u{1f1f5}\u{1f1ed}' },
  { code: '+66', country: 'Thailand', flag: '\u{1f1f9}\u{1f1ed}' },
  { code: '+60', country: 'Malaysia', flag: '\u{1f1f2}\u{1f1fe}' },
  { code: '+84', country: 'Vietnam', flag: '\u{1f1fb}\u{1f1f3}' },
  { code: '+92', country: 'Pakistan', flag: '\u{1f1f5}\u{1f1f0}' },
  { code: '+880', country: 'Bangladesh', flag: '\u{1f1e7}\u{1f1e9}' },
  { code: '+94', country: 'Sri Lanka', flag: '\u{1f1f1}\u{1f1f0}' },
  { code: '+977', country: 'Nepal', flag: '\u{1f1f3}\u{1f1f5}' },
  { code: '+234', country: 'Nigeria', flag: '\u{1f1f3}\u{1f1ec}' },
  { code: '+254', country: 'Kenya', flag: '\u{1f1f0}\u{1f1ea}' },
  { code: '+233', country: 'Ghana', flag: '\u{1f1ec}\u{1f1ed}' },
  { code: '+212', country: 'Morocco', flag: '\u{1f1f2}\u{1f1e6}' },
  { code: '+213', country: 'Algeria', flag: '\u{1f1e9}\u{1f1ff}' },
  { code: '+216', country: 'Tunisia', flag: '\u{1f1f9}\u{1f1f3}' },
  { code: '+353', country: 'Ireland', flag: '\u{1f1ee}\u{1f1ea}' },
  { code: '+43', country: 'Austria', flag: '\u{1f1e6}\u{1f1f9}' },
  { code: '+32', country: 'Belgium', flag: '\u{1f1e7}\u{1f1ea}' },
  { code: '+45', country: 'Denmark', flag: '\u{1f1e9}\u{1f1f0}' },
  { code: '+358', country: 'Finland', flag: '\u{1f1eb}\u{1f1ee}' },
  { code: '+30', country: 'Greece', flag: '\u{1f1ec}\u{1f1f7}' },
  { code: '+36', country: 'Hungary', flag: '\u{1f1ed}\u{1f1fa}' },
  { code: '+420', country: 'Czech Republic', flag: '\u{1f1e8}\u{1f1ff}' },
  { code: '+40', country: 'Romania', flag: '\u{1f1f7}\u{1f1f4}' },
  { code: '+380', country: 'Ukraine', flag: '\u{1f1fa}\u{1f1e6}' },
  { code: '+972', country: 'Israel', flag: '\u{1f1ee}\u{1f1f1}' },
  { code: '+962', country: 'Jordan', flag: '\u{1f1ef}\u{1f1f4}' },
  { code: '+961', country: 'Lebanon', flag: '\u{1f1f1}\u{1f1e7}' },
  { code: '+964', country: 'Iraq', flag: '\u{1f1ee}\u{1f1f6}' },
  { code: '+98', country: 'Iran', flag: '\u{1f1ee}\u{1f1f7}' },
  { code: '+993', country: 'Turkmenistan', flag: '\u{1f1f9}\u{1f1f2}' },
  { code: '+56', country: 'Chile', flag: '\u{1f1e8}\u{1f1f1}' },
  { code: '+57', country: 'Colombia', flag: '\u{1f1e8}\u{1f1f4}' },
  { code: '+54', country: 'Argentina', flag: '\u{1f1e6}\u{1f1f7}' },
  { code: '+51', country: 'Peru', flag: '\u{1f1f5}\u{1f1ea}' },
  { code: '+58', country: 'Venezuela', flag: '\u{1f1fb}\u{1f1ea}' },
  { code: '+593', country: 'Ecuador', flag: '\u{1f1ea}\u{1f1e8}' },
  { code: '+974', country: 'Qatar', flag: '\u{1f1f6}\u{1f1e6}' },
  { code: '+973', country: 'Bahrain', flag: '\u{1f1e7}\u{1f1ed}' },
  { code: '+968', country: 'Oman', flag: '\u{1f1f4}\u{1f1f2}' },
  { code: '+965', country: 'Kuwait', flag: '\u{1f1f0}\u{1f1fc}' },
  { code: '+852', country: 'Hong Kong', flag: '\u{1f1ed}\u{1f1f0}' },
  { code: '+886', country: 'Taiwan', flag: '\u{1f1f9}\u{1f1fc}' },
  { code: '+853', country: 'Macau', flag: '\u{1f1f2}\u{1f1f4}' },
];
